// extracted by mini-css-extract-plugin
export default {"root":"_2rs8z","preview-icon":"_3Fmi5","previewIcon":"_3Fmi5","icon":"_1beoV","filename":"_1sjid","extension":"_3bgzh","file-info":"_1OMcf","fileInfo":"_1OMcf","updated":"_33aiq"};